export const CURRENCY_TO_LOCALES: {
    [key: string]: string;
} = {
    INR: "en-IN",
    USD: "en-US",
};

export const DEFAULT_INTERNATIONAL_LOCALE = CURRENCY_TO_LOCALES.USD;
export const DEFAULT_DOMESTIC_LOCALE = CURRENCY_TO_LOCALES.INR;
